import { InvoicingapipbInvoice } from '@itsrever/rever-api'

export type InvoiceState =
  | 'draft'
  | 'pending'
  | 'payment_processing'
  | 'past_due'
  | 'payment_failed'
  | 'paid'
  | 'void'
  | 'uncollectible'

export type Tone = 'neutral' | 'success' | 'warning' | 'danger'

const TONES: Record<InvoiceState, Tone> = {
  draft: 'neutral',
  pending: 'warning',
  payment_processing: 'neutral',
  past_due: 'danger',
  payment_failed: 'danger',
  paid: 'success',
  void: 'neutral',
  uncollectible: 'danger'
}

// Stripe calls every unpaid invoice "open", whether it is on its way, late, or refused by the
// card. Shown as one amber "pending" it reads as money in flight, which is what merchants told
// us. These are the cases told apart.
export function invoiceState(
  invoice: InvoicingapipbInvoice,
  now = new Date()
): InvoiceState | undefined {
  const status = invoice.status ?? ''
  if (status !== 'open') {
    return status in TONES ? (status as InvoiceState) : undefined
  }

  // A payment the bank is still settling has been made, however long it takes, so it is neither
  // late nor failed. The same rule invoicing-api follows before it blocks a client.
  if (invoice.payment_processing) return 'payment_processing'

  const due = invoice.due_at ? new Date(invoice.due_at) : undefined
  if (due && !Number.isNaN(due.getTime()) && due < now) return 'past_due'
  if (invoice.payment_failed) return 'payment_failed'
  return 'pending'
}

export function stateTone(state: InvoiceState): Tone {
  return TONES[state]
}
